import React from "react";
import {
  FaCarSide,
  FaBridge,
  FaBuilding,
  FaTools,
  FaIndustry,
  FaWeightHanging,
  FaRadiation,
  FaBolt,
  FaTrain,
  FaRoad,
  FaShip,
  FaWarehouse,
} from "react-icons/fa";
import Specialities from "./Specialities";

const industryData = [
  { title: "Auto components", icon: <FaCarSide /> },
  // { title: "Bridges", icon: <FaBridge /> },
  { title: "Buildings", icon: <FaBuilding /> },
  { title: "Construction", icon: <FaTools /> },
  { title: "General-Fabrication", icon: <FaIndustry /> },
  { title: "Lifting-Equipments", icon: <FaWeightHanging /> },

  { title: "Railways", icon: <FaTrain /> },
  { title: "Roads", icon: <FaRoad /> },
  { title: "Steel-Buildings", icon: <FaWarehouse /> },

  { title: "Ship-Building", icon: <FaShip /> },
    { title: "Nuclear-Sector", icon: <FaRadiation /> },
  { title: "Power-Sector", icon: <FaBolt /> },
];

const Feature = () => {
  return (
<div className="w-full  mx-auto flex flex-col items-center">
  {/* Title */}
  <div className=" p-4 w-full">
    <div className="text-center mb-10">
      <h2 className="text-3xl sm:text-4xl font-bold text-[#114497] mb-2">
        INDUSTRIES WE CATER
      </h2>
    </div>

    {/* Icon Grid */}
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-12 w-full max-w-screen-xl mx-auto p-4 text-center">
      {industryData.map((item, index) => (
        <div
          key={index}
          className="flex flex-col items-center hover:cursor-pointer text-[#fbb613] transition-transform duration-300 hover:-translate-y-8"
        >
          <div className="text-5xl mb-2">{item.icon}</div>
          <p className="text-black text-base font-medium">{item.title}</p>
        </div>
      ))}
    </div>
  </div>

  <Specialities />
</div>

  );
};

export default Feature;
